import { render, staticRenderFns } from "./DashboardHrRecruit.vue?vue&type=template&id=da80b78a&scoped=true"
import script from "./DashboardHrRecruit.vue?vue&type=script&lang=js"
export * from "./DashboardHrRecruit.vue?vue&type=script&lang=js"
import style0 from "./DashboardHrRecruit.vue?vue&type=style&index=0&id=da80b78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da80b78a",
  null
  
)

export default component.exports